export default {
    data () {
        return {
            stars: {
                full: 'star',
                half: 'star_half',
                empty: 'star_border'
            }
        };
    },
    methods: {
        getStars (val) {
            let localVal = Number(val);
            let arr = new Array(5);
            return arr.fill(0, 0).map(i => {
                let star;

                if (localVal <= 0) star = this.stars.empty;
                else if (localVal < 1) star = this.stars.half;
                else if (localVal >= 1) star = this.stars.full;

                localVal = localVal - 1;

                return star;
            });
        }
    }
};
